import React, { useEffect, useRef } from "react";
import "./LeftSideScrollbar.scss";

const LeftSideScrollbar = ({ children }) => {
  const containerRef = useRef(null);
  const thumbRef = useRef(null);
  const isDragging = useRef(false);
  const startY = useRef(0);
  const startScrollTop = useRef(0);

  useEffect(() => {
    const el = containerRef.current;

    const updateThumb = () => {
      if (!thumbRef.current) return;

      const scrollable = el.scrollHeight - el.clientHeight;
      const scrolled = el.scrollTop;
      const trackHeight = el.clientHeight;
      const lengthFactor = 0.12;
      const thumbHeight = trackHeight * lengthFactor;

      const maxThumbTravel = trackHeight - thumbHeight;
      const scrollPercent = scrollable > 0 ? scrolled / scrollable : 0;
      const top = scrollPercent * maxThumbTravel;

      thumbRef.current.style.height = `${thumbHeight}px`;

      if (scrollable <= 0) {
        thumbRef.current.style.transform = `translateY(0px)`;
        return;
      }

      thumbRef.current.style.transform = `translateY(${top}px)`;
    };

    const handleMouseDown = e => {
      isDragging.current = true;
      startY.current = e.clientY;
      startScrollTop.current = el.scrollTop;
      document.body.style.userSelect = "none";
    };

    const handleMouseMove = e => {
      if (!isDragging.current) return;

      const trackHeight = el.clientHeight;
      const lengthFactor = 0.12;
      const thumbHeight = trackHeight * lengthFactor;
      const maxThumbTravel = trackHeight - thumbHeight;
      const scrollable = el.scrollHeight - el.clientHeight;

      const deltaY = e.clientY - startY.current;
      const scrollRatio = scrollable / maxThumbTravel;
      el.scrollTop = startScrollTop.current + deltaY * scrollRatio;
    };

    const handleMouseUp = () => {
      isDragging.current = false;
      document.body.style.userSelect = "";
    };

    el.addEventListener("scroll", updateThumb);
    thumbRef.current.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    const resizeObserver = new ResizeObserver(updateThumb);
    resizeObserver.observe(el);
    updateThumb();

    return () => {
      el.removeEventListener("scroll", updateThumb);
      thumbRef.current?.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={containerRef} className="custom-scroll-container">
        {children}
      </div>
      <div className="custom-scrollbar-track">
        <div ref={thumbRef} className="custom-scrollbar-thumb" />
      </div>
    </>
  );
};

export default LeftSideScrollbar;
